<template>
  <div>
    <div class="total-holder">
      <p v-if="showSale && sale.tagline" class="green-text bold">{{ sale.tagline }}</p>
      <template
          v-if="pricingValues[config.productName].savings &&
            config.productName !== 'GOTB' &&
            !isTrial">
        <p class="item">
          <span>TunnelBear ({{products[config.productName].cycleMonths}} months)</span>
          <span class="value">{{'$' + pricingValues[config.productName].fullPrice}}</span>
        </p>
        <p v-if="pricingValues[config.productName].savings.plan && pricingValues[config.productName].savings.plan.value > 0"
          class="item discount"
          data-cy="copy--discount">
          <span v-if="showSale">{{sale.title || 'Sale'}} {{pricingValues[config.productName].savings.plan.percent}}% discount</span>
          <span v-else>{{products[config.productName].desc}} {{pricingValues[config.productName].savings.plan.percent}}% discount</span>
          <span class="value">- {{'$' + pricingValues[config.productName].savings.plan.value}}</span>
        </p>
        <p v-if="pricingValues[config.productName].savings.additional"
          class="item discount"
          data-cy="copy--coupon">
          <span v-if="showCoupon" class="coupon-desc">
            Coupon: {{pricing[config.productName].coupon.code}}
            <span class="fine-print-lg">{{pricing[config.productName].coupon.description}}</span>
          </span>
          <span v-else>Current plan proration</span>
          <span class="value">- {{'$' + pricingValues[config.productName].savings.additional.value}}</span>
        </p>
      </template>
      <hr>
      <p class="item total" data-cy="pay-total">
        <span>Order&nbsp;Total:</span>
        <span>
          <span class="value">
            {{'$' + pricingValues[config.productName].chargePrice}}
          </span>
          <span class="tax" v-if="!isTrial && Number(pricingValues[config.productName].chargePrice) !== 0">{{tax}}</span>
        </span>
      </p>
      <div v-if="complianceRequired" class="form-area">
        <announce v-if="complianceError" addClass="compliance">
          <p>{{compliance.locations[location.country][location.state].copy}}</p>
          <p>Please <router-link :to="{name: 'support'}" target="_blank">contact Support</router-link> if you have any questions.</p>
        </announce>
        <label for="compliance" class="checkbox" :class="{'error': complianceError && !this.compliance.agree}">
          <input v-model="compliance.agree"
            type="checkbox"
            id="compliance"
            name="compliance"
            :value="true">
          <span class="check"></span>
          <strong>{{ compliance.locations[location.country][location.state].agreement }}</strong>
        </label>
      </div>
    </div>
  </div>
</template>
<script>
import is from 'is_js'
import services from '../../services/services.js'
import taxList from '@/data/taxes.json'
import products from '@/data/product-details.js'

export default {
  name: 'charge-price',
  data () {
    return {
      taxData: taxList,
      paymentCountry: '',
      locationData: {},
      products,
      compliance: {
        agree: false,
        locations: {
          'US': {
            'VT': {
              copy: 'Dear Vermonter, because of local consumer protections laws, you will have to manually opt-in for automatic renewal on annual TunnelBear subscriptions.',
              agreement: 'I opt-in to automatic renewal'
            }
          }
        }
      },
      complianceError: false
    }
  },
  props: {
    'pricing': Object,
    'pricingValues': Object,
    'config': Object
  },
  computed: {
    sale: function () {
      return this.$store.state.pricingService.sale
    },
    showSale: function () {
      const coupon = this.pricing[this.config.productName].coupon
      return this.sale.isLive &&
        coupon &&
        this.sale.couponProducts[coupon.code] === this.config.productName
    },
    showCoupon: function () {
      return !!this.pricing[this.config.productName].coupon &&
        this.pricingValues[this.config.productName].savings.additional &&
        !this.sale.isLive
    },
    isTrial: function () {
      return (this.config.productName.includes('TRIAL') ||
        this.pricingValues[this.config.productName].chargePrice < 0.1) &&
        this.pricing[this.config.productName].nextBillDate
    },
    tax: function () {
      let taxLocation = this.taxData[this.location.country]
      let taxText = ''
      if (taxLocation) {
        if (taxLocation.states && this.location.state && taxLocation.states[this.location.state]) {
          taxLocation = taxLocation.states[this.location.state]
        }

        if (taxLocation.display_name) {
          const inclusive = taxLocation.inclusive ? 'Incl.' : '+'
          taxText = `${inclusive} ${taxLocation.display_name}`
        }
      }

      return taxText
    },
    location: function () {
      return this.locationData || {}
    },
    complianceRequired: function () {
      return this.compliance.locations[this.location.country] &&
        this.compliance.locations[this.location.country][this.location.state] &&
        this.products[this.config.productName].renews &&
        this.products[this.config.productName].cycleYears > 0
    }
  },
  created: function () {
    this.$root.$on('countryChange', data => {
      this.locationData = data
      if (this.complianceRequired) this.compliance.agree = false
    })
    this.getTaxData()
  },
  methods: {
    getTaxData: function () {
      this.$http.get(this.ENV.paymentBaseUrl + '/taxinfo').then((response) => {
        this.taxData = response.data
      })
    },
    isCompliant: function () {
      if (this.complianceRequired && !this.compliance.agree) {
        this.complianceError = true
      }
      return !(this.complianceRequired && !this.compliance.agree)
    }
  }
}
</script>

<style scoped lang="stylus" src="./charge-price.styl" >
